import { notify } from 'notifications';
import { RollbackEventsByProductionIdModel } from 'services/production-workflow.model';
import { ProductionWorkflowService } from 'services/production-workflow.service';
import { StateController } from 'state-controller';

export type RollBackEventsModalState = {
  isOpen: boolean;
  isLoading: boolean;
  productName: string;
  rollbackEvents: RollbackEventsByProductionIdModel[];
};

const defaultState: RollBackEventsModalState = {
  isOpen: false,
  isLoading: false,
  productName: '',
  rollbackEvents: [],
};

const stateController = new StateController<RollBackEventsModalState>('ROLL_BACK_MODAL', defaultState);

export class RollBackModalActions {
  static openModal(productionId: string, productName: string) {
    return async (dispatch) => {
      try {
        dispatch(stateController.setState({ isOpen: true, productName, isLoading: true }));

        const response = await ProductionWorkflowService.getRollbackEvents(productionId);

        dispatch(stateController.setState({ rollbackEvents: response }));
      } catch (error) {
        notify.error(error.message);
      } finally {
        dispatch(stateController.setState({ isLoading: false }));
      }
    };
  }

  static closeModal() {
    return (dispatch) => {
      dispatch(stateController.setState({ isOpen: false }));
    };
  }
}

export const rollBackEventsModalReducer = stateController.getReducer();
